import { DOCUMENT } from '@angular/common';
import { Injectable, inject, signal } from '@angular/core';

const WIDGET_SELECTOR = '[data-chatbot-host="1"]';

@Injectable({ providedIn: 'root' })
export class Crm2ChatWidgetService {
  private readonly document = inject(DOCUMENT);
  private readonly routeAllowed = signal(false);
  private readonly widgetReady = signal(false);
  readonly showLoader = signal(false);
  private observer: MutationObserver | null = null;

  setRouteAllowed(allowed: boolean): void {
    this.routeAllowed.set(allowed);
    window.ExternalScripts?.syncCrm2ChatWidget(allowed);

    if (allowed) {
      this.watchForWidget();
    } else {
      this.stopWatching();
      this.widgetReady.set(false);
      this.showLoader.set(false);
    }
  }

  private watchForWidget(): void {
    if (this.document.querySelector(WIDGET_SELECTOR)) {
      this.widgetReady.set(true);
      this.showLoader.set(false);
      return;
    }

    this.widgetReady.set(false);
    this.showLoader.set(true);

    this.stopWatching();
    this.observer = new MutationObserver(() => {
      if (this.document.querySelector(WIDGET_SELECTOR)) {
        this.widgetReady.set(true);
        this.showLoader.set(false);
        this.stopWatching();
      }
    });
    this.observer.observe(this.document.body, { childList: true, subtree: true });
  }

  private stopWatching(): void {
    this.observer?.disconnect();
    this.observer = null;
  }
}
